import FeaturedContentApi from '../api/FeaturedContentApi';
import FeaturedContentConstants from '../constants/FeaturedContentConstants';

function fetch(results) {
  return {
    types: [
      FeaturedContentConstants.FEATURED_CONTENT_REQUEST,
      FeaturedContentConstants.FEATURED_CONTENT_SUCCESS,
      FeaturedContentConstants.FEATURED_CONTENT_FAILURE
    ],
    apiRequest: (state, client) => FeaturedContentApi.fetch(client, results)
  };
}

export default {
  fetch
};



// WEBPACK FOOTER //
// ./app/actions/FeaturedContentActions.js